import React from 'react'
import { Link } from 'react-router-dom';
import paths from '../../routes/paths';
import { imageCodes, titleCodes, textCodes, videoCodes } from '../../template_codes/encore/home_page_codes';

export default function Body() {
    
    return (
        <div >
            {/*                     banner                           */}
            <div class="carousel w-full ">
                <div class="carousel-item relative w-full hidden flex md:inline-flex">
                    <img src={imageCodes.banImage.image} class="w-full" />
                </div>
            </div>
            <div class="carousel w-full">
                <div class="carousel-item relative w-full lg:hidden">
                    <img src={imageCodes.Mobban.image} class="w-full " />
                </div>
            </div>
            {/*                 end of banner                        */}

            <div className='container w-4/6 pt-5 '>
                {/* 
                <svg className='w-20 animate-spin object-right-bottom flex  inline-flex opacity-50' xmlns="http://www.w3.org/2000/svg" width="3.5em" height="3.5em" preserveAspectRatio="xMidYMid meet" viewBox="0 0 64 64"><path fill="#FF84AE" d="M38.2 34.6L64 32l-25.8-2.6l16.4-20l-20 16.4L32 0l-2.6 25.8l-20-16.4l16.4 20L0 32l25.8 2.6l-16.4 20l20-16.4L32 64l2.6-25.8l20 16.4z" /></svg>*/}
                <h1 className="font-bold lg:text-4xl xl:text-4xl 2xl:text-4xl 3xl:text-4xl text-center tracking-widest transition delay-150 duration-300 ease-in-out hover:animate-[bounce_3.5s_infinite] transation:1s">{titleCodes.title2.title}</h1>
                <p className='pt-3 text-justify '>{textCodes.text.text}</p>
                <div className='grid grid-cols-2 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2 2xl:grid-cols-2 3xl:grid-cols-2 gap-x-10'>
                    

                </div>

            </div>


            {/*              photo gallery section              */}
            <div className="container pt-10 px-2">
                <div className="grid grid-cols-2 xs:grid-cols-3 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-4 3xl:grid-cols-4">
                    <div className="card w-40 lg:w-80 xl:w-80 2xl:w-80 3xl:w-80 shadow-xl delay-1 transform ">
                        <figure className="px-5 pt-10">
                            <a href='https://encoreclothingmm.com/product/cl75nwt2315178401s6tsj7oduv'><img src={imageCodes.Product.image}></img></a>
                        </figure>
                        <div className="card-body items-center text-center">
                            <h2 className="card-title">Dawn of Angel</h2>
                            <p>19,999 K</p>

                        </div>
                    </div>

                    <div className="card w-40 lg:w-80 xl:w-80 2xl:w-80 3xl:w-80 shadow-xl delay-1 transform ">
                        <figure className="px-5 pt-10">
                            <a href='https://encoreclothingmm.com/product/cl75nwt2315178401s6tsj7oduv'><img src={imageCodes.Product1.image}></img></a>
                        </figure>
                        <div className="card-body items-center text-center">
                            <h2 className="card-title">Dawn of Angel</h2>
                            <p>19,999 K</p>

                        </div>
                    </div>

                    <div className="card w-40 lg:w-80 xl:w-80 2xl:w-80 3xl:w-80 shadow-xl delay-1 transform ">
                        <figure className="px-5 pt-10">
                            <a href='https://encoreclothingmm.com/product/cl75nwt2315178401s6tsj7oduv'><img src={imageCodes.Product3.image}></img></a>
                        </figure>
                        <div className="card-body items-center text-center">
                            <h2 className="card-title">Stubborn Tee</h2>
                            <p>15,900 K</p>

                        </div>
                    </div>

                    <div className="card w-40 lg:w-80 xl:w-80 2xl:w-80 3xl:w-80 shadow-xl delay-1 transform ">
                        <figure className="px-5 pt-10">
                            <a href='https://encoreclothingmm.com/product/cl75nwt2315178401s6tsj7oduv'><img src={imageCodes.Product4.image}></img></a>
                        </figure>
                        <div className="card-body items-center text-center">
                            <h2 className="card-title">Stubborn Tee</h2>
                            <p>15,900 K</p>

                        </div>
                    </div>

                    <div className="card w-40 lg:w-80 xl:w-80 2xl:w-80 3xl:w-80 shadow-xl delay-1 transform ">
                        <figure className="px-5 pt-10">
                            <a href='#'><img src={imageCodes.Product5.image}></img></a>
                        </figure>
                        <div className="card-body items-center text-center">
                            <h2 className="card-title">Encore Tee</h2>
                            <p>29,999 K</p>

                        </div>
                    </div>

                    <div className="card w-40 lg:w-80 xl:w-80 2xl:w-80 3xl:w-80 shadow-xl delay-1 transform ">
                        <figure className="px-5 pt-10">
                            <a href='#'><img src={imageCodes.Product7.image}></img></a>
                        </figure>
                        <div className="card-body items-center text-center">
                            <h2 className="card-title">Encore Tee</h2>
                            <p>29,999 K</p>

                        </div>
                    </div>

                </div>
            </div>


            {/*              end of photo gallery section              */}

            {/*                 photo gallery secction 2            
            <div class="flex pt-10 items-center justify-center bg-neutral-800">
                <div class="grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-4 xl:grid-cols-4">
                    <div class="group relative cursor-pointer items-center justify-center overflow-hidden transition-shadow hover:shadow-xl hover:shadow-black/30">
                        <div class="h-96 w-72">
                            <img class="h-full w-full object-cover transition-transform duration-500 group-hover:rotate-3 group-hover:scale-125" src={imageCodes.Product.image} alt="" />
                        </div>
                        <div class="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-black group-hover:from-black/70 group-hover:via-black/60 group-hover:to-black/70"></div>
                        <div class="absolute inset-0 flex translate-y-[60%] flex-col items-center justify-center px-9 text-center transition-all duration-1000 group-hover:translate-y-0">
                            <h1 class="font-dmserif text-3xl font-bold text-white pb-10">Dawn of Angel</h1>
                            <p class="mb-3 text-lg italic text-white opacity-0 transition-opacity duration-300 group-hover:opacity-100">Black Color</p>
                            <button class="rounded-full bg-neutral-900 py-2 px-3.5 font-com text-sm capitalize text-white shadow shadow-black/60">19,999 K</button>
                        </div>

                    </div>
                    <div class="group relative cursor-pointer items-center justify-center overflow-hidden transition-shadow hover:shadow-xl hover:shadow-black/30">
                        <div class="h-96 w-72">
                            <img class="h-full w-full object-cover transition-transform duration-500 group-hover:rotate-3 group-hover:scale-125" src={imageCodes.Product1.image} alt="" />
                        </div>
                        <div class="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-black group-hover:from-black/70 group-hover:via-black/60 group-hover:to-black/70"></div>
                        <div class="absolute inset-0 flex translate-y-[60%] flex-col items-center justify-center px-9 text-center transition-all duration-1000 group-hover:translate-y-0">
                            <h1 class="font-dmserif text-3xl font-bold text-white pb-10">Dawn of Angel</h1>
                            <p class="mb-3 text-lg italic text-white opacity-0 transition-opacity duration-300 group-hover:opacity-100">Black Color</p>
                            <button class="rounded-full bg-neutral-900 py-2 px-3.5 font-com text-sm capitalize text-white shadow shadow-black/60">19,999 K</button>
                        </div>
                    </div>
                    <div class="group relative cursor-pointer items-center justify-center overflow-hidden transition-shadow hover:shadow-xl hover:shadow-black/30">
                        <div class="h-96 w-72">
                            <img class="h-full w-full object-cover transition-transform duration-500 group-hover:rotate-3 group-hover:scale-125" src={imageCodes.Product3.image} alt="" />
                        </div>
                        <div class="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-black group-hover:from-black/50 group-hover:via-black/40 group-hover:to-black/40"></div>
                        <div class="absolute inset-0 flex translate-y-[60%] flex-col items-center justify-center px-9 text-center transition-all duration-1000 group-hover:translate-y-0">
                            <h1 class="font-dmserif text-3xl font-bold text-white pb-10">Stubborn Tee</h1>
                            <p class="mb-3 text-lg italic text-white opacity-0 transition-opacity duration-300 group-hover:opacity-100">Pink Color</p>
                            <button class="rounded-full bg-neutral-900 py-2 px-3.5 font-com text-sm capitalize text-white shadow shadow-black/60">15,900 K</button>
                        </div>
                    </div>
                    <div class="group relative cursor-pointer items-center justify-center overflow-hidden transition-shadow hover:shadow-xl hover:shadow-black/30">
                        <div class="h-96 w-72">
                            <img class="h-full w-full object-cover transition-transform duration-500 group-hover:rotate-3 group-hover:scale-125" src={imageCodes.Product4.image} alt="" />
                        </div>
                        <div class="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-black group-hover:from-black/50 group-hover:via-black/40 group-hover:to-black/40"></div>
                        <div class="absolute inset-0 flex translate-y-[60%] flex-col items-center justify-center px-9 text-center transition-all duration-1000 group-hover:translate-y-0">
                            <h1 class="font-dmserif text-3xl font-bold text-white pb-10">Stubborn Tee</h1>
                            <p class="mb-3 text-lg italic text-white opacity-0 transition-opacity duration-300 group-hover:opacity-100">Black Color</p>
                            <button class="rounded-full bg-neutral-900 py-2 px-3.5 font-com text-sm capitalize text-white shadow shadow-black/60">15,900 K</button>
                        </div>
                    </div>
                </div>
            </div>
            */}
            {/*                         footer fixed
                <div class="fixed bottom-16">
                    <p class="font-com text-2xl font-semibold text-white">All Images are from <a href="https://unsplash.com" class="text-blue-500">Unsplash.com</a></p>
                </div>
                 */}


            <div className="container pt-10 px-2">
                <div className="grid grid-cols-2 xs:grid-cols-3 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-4 3xl:grid-cols-4">
                    <div className="card w-40 lg:w-80 xl:w-80 2xl:w-80 3xl:w-80 shadow-xl delay-1 transform ">
                        <label className="swap swap-flip text-xl px-5 pt-10">
                            <input type="checkbox" />

                            <div className="swap-on"><img src={imageCodes.Product1.image}></img></div>
                            <div className="swap-off"><img src={imageCodes.Product.image}></img></div>
                        </label>
                        <div className="card-body items-center text-center">
                            <h2 className="card-title">Dawn of Angel</h2>
                            <p>19,999 K</p>

                        </div>
                    </div>

                    <div className="card w-40 lg:w-80 xl:w-80 2xl:w-80 3xl:w-80 shadow-xl delay-1 transform ">
                        <label className="swap swap-flip text-xl px-5 pt-10">
                            <input type="checkbox" />

                            <div className="swap-on"><img src={imageCodes.Product2.image}></img></div>
                            <div className="swap-off"><img src={imageCodes.Product3.image}></img></div>
                        </label>
                        <div className="card-body items-center text-center">
                            <h2 className="card-title">Stubborn Tee</h2>
                            <p>15,900 K</p>

                        </div>
                    </div>

                    <div className="card w-40 lg:w-80 xl:w-80 2xl:w-80 3xl:w-80 shadow-xl delay-1 transform ">
                        <label className="swap swap-flip text-xl px-5 pt-10">
                            <input type="checkbox" />

                            <div className="swap-on"><img src={imageCodes.Product9.image}></img></div>
                            <div className="swap-off"><img src={imageCodes.Product4.image}></img></div>
                        </label>
                        <div className="card-body items-center text-center">
                            <h2 className="card-title">Stubborn Tee</h2>
                            <p>15,900 K</p>

                        </div>
                    </div>


                    <div className="card w-40 lg:w-80 xl:w-80 2xl:w-80 3xl:w-80 shadow-xl delay-1 transform ">
                        <label className="swap swap-flip text-xl px-5 pt-10">
                            <input type="checkbox" />

                            <div className="swap-on"><img src={imageCodes.Product6.image}></img></div>
                            <div className="swap-off"><img src={imageCodes.Product5.image}></img></div>
                        </label>
                        <div className="card-body items-center text-center">
                            <h2 className="card-title">𝕰𝕹𝕮𝕺𝕽𝕰 Tee</h2>
                            <p>29,999 K</p>

                        </div>
                    </div>

                    <div className="card w-40 lg:w-80 xl:w-80 2xl:w-80 3xl:w-80 shadow-xl delay-1 transform ">
                        <label className="swap swap-flip text-xl px-5 pt-10">
                            <input type="checkbox" />

                            <div className="swap-on"><img src={imageCodes.Product8.image}></img></div>
                            <div className="swap-off"><img src={imageCodes.Product7.image}></img></div>
                        </label>
                        <div className="card-body items-center text-center">
                            <h2 className="card-title">𝕰𝕹𝕮𝕺𝕽𝕰 Tee</h2>
                            <p>29,999 K</p>

                        </div>
                    </div>




                </div>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-3 xl:grid-cols-3 2xl:grid-cols-3 place-items-center pb-10 pt-10 delay-1 transform ">
                <div></div>
                <div className='items-center '>
                    <button className="btn btn-outline px-10"><a href='https://encoreclothingmm.com/'>Collection</a></button>
                </div>
                <div></div>

            </div>

            {/*             annimation section                     
            <div className='flex opacity-50'>
                <svg className='w-20 animate-spin absolute right-20 top-0' xmlns="http://www.w3.org/2000/svg" width="3.5em" height="3.5em" preserveAspectRatio="xMidYMid meet" viewBox="0 0 64 64"><path fill="#FF84AE" d="M38.2 34.6L64 32l-25.8-2.6l16.4-20l-20 16.4L32 0l-2.6 25.8l-20-16.4l16.4 20L0 32l25.8 2.6l-16.4 20l20-16.4L32 64l2.6-25.8l20 16.4z" /></svg>
                <svg className='w-20 animate-spin absolute left-10 ' xmlns="http://www.w3.org/2000/svg" width="3.5em" height="3.5em" preserveAspectRatio="xMidYMid meet" viewBox="0 0 64 64"><path fill="#7257AB" d="M38.2 34.6L64 32l-25.8-2.6l16.4-20l-20 16.4L32 0l-2.6 25.8l-20-16.4l16.4 20L0 32l25.8 2.6l-16.4 20l20-16.4L32 64l2.6-25.8l20 16.4z" /></svg>
                <svg className='w-20 animate-spin absolute right-14 opacity-50' xmlns="http://www.w3.org/2000/svg" width="2.5em" height="2.5em" preserveAspectRatio="xMidYMid meet" viewBox="0 0 16 16"><g fill="#ffff00"><path d="M6 .278a.768.768 0 0 1 .08.858a7.208 7.208 0 0 0-.878 3.46c0 4.021 3.278 7.277 7.318 7.277c.527 0 1.04-.055 1.533-.16a.787.787 0 0 1 .81.316a.733.733 0 0 1-.031.893A8.349 8.349 0 0 1 8.344 16C3.734 16 0 12.286 0 7.71C0 4.266 2.114 1.312 5.124.06A.752.752 0 0 1 6 .278z" /><path d="M10.794 3.148a.217.217 0 0 1 .412 0l.387 1.162c.173.518.579.924 1.097 1.097l1.162.387a.217.217 0 0 1 0 .412l-1.162.387a1.734 1.734 0 0 0-1.097 1.097l-.387 1.162a.217.217 0 0 1-.412 0l-.387-1.162A1.734 1.734 0 0 0 9.31 6.593l-1.162-.387a.217.217 0 0 1 0-.412l1.162-.387a1.734 1.734 0 0 0 1.097-1.097l.387-1.162zM13.863.099a.145.145 0 0 1 .274 0l.258.774c.115.346.386.617.732.732l.774.258a.145.145 0 0 1 0 .274l-.774.258a1.156 1.156 0 0 0-.732.732l-.258.774a.145.145 0 0 1-.274 0l-.258-.774a1.156 1.156 0 0 0-.732-.732l-.774-.258a.145.145 0 0 1 0-.274l.774-.258c.346-.115.617-.386.732-.732L13.863.1z" /></g></svg>
                <svg className='w-20 animate-spin absolute left-52 bottom-20' xmlns="http://www.w3.org/2000/svg" width="3.5em" height="3.5em" preserveAspectRatio="xMidYMid meet" viewBox="0 0 64 64"><path fill="#ff3838" d="M38.2 34.6L64 32l-25.8-2.6l16.4-20l-20 16.4L32 0l-2.6 25.8l-20-16.4l16.4 20L0 32l25.8 2.6l-16.4 20l20-16.4L32 64l2.6-25.8l20 16.4z" /></svg>
            </div>
             */}
        </div>
    )
}
